/**
 * Gift Store analytics wrapper.
 * No-op if analytics not configured. Never includes PII.
 */

type TrackFn = (event: string, props?: Record<string, string | boolean | number>) => void;

const track: TrackFn = (event, props) => {
  if (import.meta.env.DEV) {
    console.log('[GiftStore Analytics]', event, props);
  }
  // Phase 2: wire to real analytics provider here
};

export const trackCategoryViewed = (categorySlug: string, categoryTitle: string) =>
  track('market_category_viewed', { category_slug: categorySlug, category_title: categoryTitle });

export const trackPartnerCardViewed = (
  slug: string,
  brandName: string,
  categorySlug: string,
) => track('market_partner_card_viewed', { slug, brand_name: brandName, category_slug: categorySlug });

export const trackPartnerClicked = (
  slug: string,
  brandName: string,
  categorySlug: string,
) =>
  track('market_partner_clicked', {
    slug,
    brand_name: brandName,
    category_slug: categorySlug,
    placement: 'gift_store',
  });

export const trackGiftSuggestion = (
  event: 'gift_suggestion_shown' | 'gift_suggestion_clicked' | 'gift_suggestion_skipped',
  announcementId: string,
  partnerSlug?: string,
) =>
  track(event, {
    announcement_id: announcementId,
    ...(partnerSlug ? { partner_slug: partnerSlug } : {}),
  });
